import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiChartBar, mdiAccountGroup, mdiCurrencyUsd, mdiStar, mdiRefresh } from '@mdi/js';
import { useAuth } from '../contexts/AuthContext';
import AppHeader from '../components/AppHeader';
import '../pages/Common.css';
import '../pages/Dashboard.css';
import '../pages/header.css';
import './Reports.css';
/**
 * Reports - Placeholder page for studio reporting features
 * Portal type: Sub-Portal Feature (.sub-portal-header-card)
 */
const Reports = () => {
    const navigate = useNavigate();
    const { checkPermission } = useAuth();
    const backPath = checkPermission('viewDashboard') ? '/manage-finances' : '/classes';
    const backLabel = checkPermission('viewDashboard') ? '← Manage Finances' : '← Classes';

    const plannedReports = [
        { icon: mdiAccountGroup, title: 'Attendance Summaries', description: 'Track student attendance by class, term, and date range' },
        { icon: mdiCurrencyUsd, title: 'Revenue Reports', description: 'View payment totals, outstanding balances, and revenue trends' },
        { icon: mdiStar, title: 'Instructor Performance', description: 'Sessions taught, student counts, and retention per instructor' },
        { icon: mdiRefresh, title: 'Student Retention', description: 'Re-enrolment rates, drop-off analysis, and cohort tracking' },
    ];

    return (
        <div className="dashboard-container org-console">
            <AppHeader />

            <div className="dashboard-main">
                <div className="dashboard-content-wrapper reports-page" style={{ maxWidth: '900px' }}>
                    {/* Portal Header Card */}
                    <div className="sub-portal-header-card">
                        <div className="sub-portal-header-title-row">
                            <button
                                onClick={() => navigate(backPath)}
                                className="back-nav-btn">
                                {backLabel}
                            </button>
                            <h1 className="sub-portal-header-title">
                                <Icon path={mdiChartBar} size={1.2} color="#451f78" style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                                Reports
                            </h1>
                            <div style={{ width: '100px' }} />
                        </div>
                        <p className="sub-portal-header-subtitle">
                            Studio analytics, attendance tracking, and performance insights.
                        </p>
                    </div>

                    {/* Coming Soon Content */}
                    <div className="content-card reports-coming-soon">
                        <h3 className="reports-coming-title">
                            Coming Soon{' '}
                            <Link to="/help/contact" className="reports-coming-feedback-link">
                                (Let us know what you&rsquo;d like to see here)
                            </Link>
                        </h3>
                        <p className="reports-coming-description">
                            Powerful reporting tools are on the way. Here&rsquo;s what&rsquo;s planned:
                        </p>
                        <div className="reports-planned-grid">
                            {plannedReports.map((report) => (
                                <div key={report.title} className="reports-planned-item">
                                    <Icon path={report.icon} size={1.2} color="#451f78" />
                                    <div>
                                        <p className="reports-planned-title">{report.title}</p>
                                        <p className="reports-planned-description">{report.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reports;
